export const ROUTING = 'ROUTING';
export const FETCH_FORM = 'FETCH_FORM';
export const GET_DIRECTIONS = 'GET_DIRECTIONS';
export const FETCH_FORMS = 'FETCH_FORMS';
export const ADD_VALUE = 'ADD_VALUE';
export const SET_SECTION = 'SET_SECTION';
export const CLEAR_VALUES = 'CLEAR_VALUES';
export const SET_FORM_UID = 'SET_FORM_UID';
export const FETCH_VALUES = 'FETCH_VALUES';
export const OPEN_FORM = 'OPEN_FORM';
export const CHECKED_PANEL = 'CHECKED_PANEL';
export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const AUTH_USER_ERROR= 'AUTH_USER_ERROR';
export const ATTEMPT_TO_SEND = 'ATTEMPT_TO_SEND';
export const SET_STATUS_DEFAULT = 'SET_STATUS_DEFAULT';
export const CREATE_REQUEST_BEFORE = 'CREATE_REQUEST_BEFORE';
export const REQUEST_UNCHEK_UPDATE = 'REQUEST_UNCHEK_UPDATE';
export const MARK_VISITED = 'MARK_VISITED';
export const SET_ERROR = 'SET_ERROR';
export const MARK_ALL_VISITED = 'MARK_ALL_VISITED';
export const LOADING_START = 'LOADING_START';
export const LOADING_FINISH = 'LOADING_FINISH';
export const FETCH_COMPANIES = 'FETCH_COMPANIES';
export const FETCH_MM_PROCESS = 'FETCH_MM_PROCESS';
export const FETCH_MENTOR_PROCESS = 'FETCH_MENTOR_PROCESS';
export const ACCEPT_MENTOR_PROCESS = 'ACCEPT_MENTOR_PROCESS';
export const FETCH_SLAVE_MENTORS = 'FETCH_SLAVE_MENTORS';
export const FETCH_SETTINGS = 'FETCH_SETTINGS';
export const FETCH_SETTINGS_FINISHED = 'FETCH_SETTINGS_FINISHED';
export const SET_INITIAL_ENTITY = 'SET_INITIAL_ENTITY';
export const SET_NEW_PROCESS_ID = 'SET_NEW_PROCESS_ID';
export const SET_MENTOR = 'SET_MENTOR';
export const GET_FLOWS = 'GET_FLOWS';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const FETCH_HISTORY = 'FETCH_HISTORY';
export const SET_HISTORY = 'SET_HISTORY';
export const SET_DYNAMIC_OPTIONS = 'SET_DYNAMIC_OPTIONS';
export const GET_APPOINTED_STATUS = 'GET_APPOINTED_STATUS'
